/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { css, keyframes } from '@emotion/react';
import { CircularProgress } from '@mui/material';
import { withMyTheme } from '../../theme/theme';
import { MainConfig } from '../../../mainConfig/configHelper';
import { isMobile } from '../../theme/isMobile';

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;

const OverlayStyle = withMyTheme((theme) => css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${theme.palette.background.default};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.5s ease-in-out;
  
  &.loaded {
    animation: ${fadeOut} 0.8s forwards;
  }
`);

const LoaderContainerStyle = withMyTheme(() => css`
  display: flex;
  flex-direction: column;
  align-items: center;
`);

const ProgressStyle = withMyTheme((theme) => css`
  color: ${theme.palette.primary.main};
`);

const LoadingTextStyle = withMyTheme((theme) => css`
  margin-top: 1rem;
  font-family: ${theme.typography.body1.fontFamily};
  color: ${theme.palette.text.secondary};
  font-size: 1rem;
  letter-spacing: 2px;
`);

export const LoadingOverlay: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imageToLoad = isMobile() ? MainConfig.mainImages.mobileImage : MainConfig.mainImages.desktopImage
  
  useEffect(() => {
    const img = new Image();
    img.src = imageToLoad;
    
    const handleImageLoaded = () => {
      // Add a small delay to ensure smooth transition
      setTimeout(() => {
        setIsLoaded(true);
      }, 500);
    };
    
    if (img.complete) {
      handleImageLoaded();
    } else {
      img.addEventListener('load', handleImageLoaded);
    }
    
    return () => {
      img.removeEventListener('load', handleImageLoaded);
    };
  }, [imageToLoad]);
  
  return (
    <div css={OverlayStyle} className={isLoaded ? 'loaded' : ''}>
      <div css={LoaderContainerStyle}>
        <CircularProgress size={'7vh'} thickness={2.5} css={ProgressStyle} />
        <div css={LoadingTextStyle}>LOADING</div>
      </div>
    </div>
  );
};
